import type { NextApiRequest, NextApiResponse } from 'next'
import { postnordApi, useLocaleCredentials as setLocaleCredentials } from 'api'
import {
  type Language,
  type PostNordValidatePostalCodeRequest,
  type PostNordValidatePostalCodeResponse
} from 'ecosystem'
import { handlerWithLogging } from '../../../logging'

export const postnordValidatePostalCodeHandler = handlerWithLogging(
  async (
    req: NextApiRequest,
    res: NextApiResponse<PostNordValidatePostalCodeResponse | { error: string }>
  ) => {
    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)
    if (req.method !== 'POST') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const body = req.body as PostNordValidatePostalCodeRequest

    let responseError: string | null

    try {
      const { data, error } = await postnordApi.postalCodeValidation(body)

      if (data) {
        res.status(200).json(data)
        return
      }

      responseError = error ?? 'Data is not found'
    } catch (e) {
      responseError = e instanceof Error ? e.message : 'unknown'
    }

    res.status(400).json({ error: responseError })
  }
)
